import {Controller} from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {

    connect() {
        console.log('has text switch');
        if (sessionStorage.getItem('list_state') === 'true') {
            const that = $(this.element);
            const target = that.data('target');
            that.addClass('text-switch--on');
            $(target).addClass('list');
        }
    }

    toggle(event) {
        const that = $(this.element);
        const target = that.data('target');
        that.toggleClass('text-switch--on');
        $(target).toggleClass('list');
        if (sessionStorage.getItem('list_state') === "true") {
            sessionStorage.setItem('list_state', 'false');
        } else {
            sessionStorage.setItem('list_state', 'true');
        }
    }
}